import React from 'react';

import * as T from './About.types';

type AttributesProps = {
  items: T.About[];
};

export const Attributes = ({ items }: AttributesProps) => {
  return (
    <div className="content">
      {items.map((attr) => {
        return (
          <div key={attr.image.url} className="atributo">
            <img
              className="icon"
              alt={attr.title}
              src={attr.image.url}
              width={67}
              height={67}
              data-lazzy
            />
            <h5>{attr.title}</h5>
            <p>{attr.text}</p>
          </div>
        );
      })}
    </div>
  );
};
